/**
 * Subscription Cancel Page
 * Shown when user cancels Stripe checkout
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, HelpCircle } from 'lucide-react';
import { Button } from './ui/button';

const SubscriptionCancel = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Cancel Card */}
        <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-3xl p-8 text-center border border-gray-700 shadow-2xl">
          {/* Icon */}
          <div className="mx-auto w-20 h-20 bg-gray-800 rounded-full flex items-center justify-center mb-6">
            <XCircle className="w-12 h-12 text-gray-500" />
          </div>
          
          {/* Title */}
          <h1 className="text-2xl font-bold text-white mb-2">
            Checkout Cancelled
          </h1>
          
          {/* Subtitle */}
          <p className="text-gray-400 mb-6">
            No worries! Your subscription wasn't processed. You can try again anytime.
          </p>
          
          {/* Info Box */}
          <div className="bg-gray-800/50 rounded-2xl p-4 mb-6 text-left">
            <h3 className="text-gray-300 text-sm font-semibold mb-2 flex items-center gap-2">
              <HelpCircle className="w-4 h-4 text-amber-400" />
              Common reasons for cancellation:
            </h3>
            <ul className="space-y-1 text-sm text-gray-400">
              <li>• Need more time to decide</li>
              <li>• Want to explore free features first</li>
              <li>• Payment method issues</li>
            </ul>
          </div>
          
          {/* Buttons */}
          <div className="space-y-3">
            <Button
              onClick={() => navigate('/dashboard')}
              className="w-full bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-semibold py-5 rounded-xl"
              data-testid="cancel-go-to-dashboard"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Back to Dashboard
            </Button>
            
            <Button
              onClick={() => {
                // Could trigger checkout again, for now just go back
                navigate('/dashboard');
              }}
              variant="outline"
              className="w-full border-gray-600 text-gray-300 hover:bg-gray-800 py-5 rounded-xl"
              data-testid="cancel-try-again"
            >
              Try Again Later
            </Button>
          </div>
        </div>
        
        {/* Footer */}
        <p className="text-center text-gray-500 text-sm mt-6">
          Questions? Contact support@prospermind.com
        </p>
      </div>
    </div>
  );
};

export default SubscriptionCancel;
